[
  {
    "code": "AU-SA-ADL",
    "name": "Adelaide"
  },
  {
    "code": "AU-SA-ADH",
    "name": "Adelaide Hills"
  },
  {
    "code": "AU-WA-ALB",
    "name": "Albany"
  },
  {
    "code": "AU-NSW-ALB",
    "name": "Albury"
  },
  {
    "code": "AU-SA-ALE",
    "name": "Alexandrina"
  },
  {
    "code": "AU-NT-ALI",
    "name": "Alice Springs"
  },
  {
    "code": "AU-VIC-ALP",
    "name": "Alpine"
  },
  {
    "code": "AU-NT-ALY",
    "name": "Alyangula"
  },
  {
    "code": "AU-SA-ANA",
    "name": "Anangu Pitjantjatjara"
  },
  {
    "code": "AU-VIC-ARA",
    "name": "Ararat"
  },
  {
    "code": "AU-WA-ARM",
    "name": "Armadale"
  },
  {
    "code": "AU-NSW-ARM",
    "name": "Armidale Dumaresq"
  },
  {
    "code": "AU-WA-ASH",
    "name": "Ashburton"
  },
  {
    "code": "AU-NSW-ASH",
    "name": "Ashfield"
  },
  {
    "code": "AU-NSW-AUB",
    "name": "Auburn"
  },
  {
    "code": "AU-WA-AUG",
    "name": "Augusta-Margaret River"
  },
  {
    "code": "AU-QLD-AUR",
    "name": "Aurukun"
  },
  {
    "code": "AU-VIC-BAL",
    "name": "Ballarat"
  },
  {
    "code": "AU-NSW-BLL",
    "name": "Ballina"
  },
  {
    "code": "AU-QLD-BAL",
    "name": "Balonne"
  },
  {
    "code": "AU-NSW-BLR",
    "name": "Balranald"
  },
  {
    "code": "AU-QLD-BAN",
    "name": "Banana"
  },
  {
    "code": "AU-NSW-BAN",
    "name": "Bankstown"
  },
  {
    "code": "AU-VIC-BAN",
    "name": "Banyule"
  },
  {
    "code": "AU-QLD-BCL",
    "name": "Barcaldine"
  },
  {
    "code": "AU-QLD-BAR",
    "name": "Barcoo"
  },
  {
    "code": "AU-NT-BAR",
    "name": "Barkly"
  },
  {
    "code": "AU-SA-BAR",
    "name": "Barossa"
  },
  {
    "code": "AU-SA-BRW",
    "name": "Barunga West"
  },
  {
    "code": "AU-VIC-BAS",
    "name": "Bass Coast"
  },
  {
    "code": "AU-WA-BAS",
    "name": "Bassendean"
  },
  {
    "code": "AU-NSW-BAT",
    "name": "Bathurst Regional"
  },
  {
    "code": "AU-VIC-BAW",
    "name": "Baw Baw"
  },
  {
    "code": "AU-VIC-BAY",
    "name": "Bayside"
  },
  {
    "code": "AU-WA-BAY",
    "name": "Bayswater"
  },
  {
    "code": "AU-NSW-BEG",
    "name": "Bega Valley"
  },
  {
    "code": "AU-NSW-BEL",
    "name": "Bellingen"
  },
  {
    "code": "AU-WA-BEL",
    "name": "Belmont"
  },
  {
    "code": "AU-NT-BEL",
    "name": "Belyuen"
  },
  {
    "code": "AU-VIC-BEN",
    "name": "Benalla"
  },
  {
    "code": "AU-SA-BER",
    "name": "Berri and Barmera"
  },
  {
    "code": "AU-NSW-BER",
    "name": "Berrigan"
  },
  {
    "code": "AU-WA-BEV",
    "name": "Beverley"
  },
  {
    "code": "AU-QLD-BLA",
    "name": "Blackall Tambo"
  },
  {
    "code": "AU-NSW-BLK",
    "name": "Blacktown"
  },
  {
    "code": "AU-NSW-BLA",
    "name": "Bland"
  },
  {
    "code": "AU-NSW-BLY",
    "name": "Blayney"
  },
  {
    "code": "AU-NSW-BLU",
    "name": "Blue Mountains"
  },
  {
    "code": "AU-WA-BOD",
    "name": "Boddington"
  },
  {
    "code": "AU-NSW-BOG",
    "name": "Bogan"
  },
  {
    "code": "AU-NSW-BOM",
    "name": "Bombala"
  },
  {
    "code": "AU-NSW-BOO",
    "name": "Boorowa"
  },
  {
    "code": "AU-VIC-BOR",
    "name": "Boroondara"
  },
  {
    "code": "AU-NSW-BOT",
    "name": "Botany Bay"
  },
  {
    "code": "AU-QLD-BOU",
    "name": "Boulia"
  },
  {
    "code": "AU-NSW-BOU",
    "name": "Bourke"
  },
  {
    "code": "AU-WA-BOY",
    "name": "Boyup Brook"
  },
  {
    "code": "AU-TAS-BRE",
    "name": "Break O'Day"
  },
  {
    "code": "AU-NSW-BRE",
    "name": "Brewarrina"
  },
  {
    "code": "AU-WA-BRI",
    "name": "Bridgetown-Greenbushes"
  },
  {
    "code": "AU-TAS-BRI",
    "name": "Brighton"
  },
  {
    "code": "AU-VIC-BRI",
    "name": "Brimbank"
  },
  {
    "code": "AU-QLD-BRI",
    "name": "Brisbane"
  },
  {
    "code": "AU-NSW-BRO",
    "name": "Broken Hill"
  },
  {
    "code": "AU-WA-BRK",
    "name": "Brookton"
  },
  {
    "code": "AU-WA-BRM",
    "name": "Broome"
  },
  {
    "code": "AU-WA-BRT",
    "name": "Broomehill-Tambellup"
  },
  {
    "code": "AU-WA-BRU",
    "name": "Bruce Rock"
  },
  {
    "code": "AU-QLD-BUL",
    "name": "Bulloo"
  },
  {
    "code": "AU-VIC-BUL",
    "name": "Buloke"
  },
  {
    "code": "AU-WA-BUN",
    "name": "Bunbury"
  },
  {
    "code": "AU-QLD-BUN",
    "name": "Bundaberg"
  },
  {
    "code": "AU-QLD-BDK",
    "name": "Burdekin"
  },
  {
    "code": "AU-QLD-BRK",
    "name": "Burke"
  },
  {
    "code": "AU-TAS-BUR",
    "name": "Burnie"
  },
  {
    "code": "AU-SA-BUR",
    "name": "Burnside"
  },
  {
    "code": "AU-NSW-BUR",
    "name": "Burwood"
  },
  {
    "code": "AU-WA-BUS",
    "name": "Busselton"
  },
  {
    "code": "AU-NSW-BYR",
    "name": "Byron"
  },
  {
    "code": "AU-NSW-CAB",
    "name": "Cabonne"
  },
  {
    "code": "AU-QLD-CAI",
    "name": "Cairns"
  },
  {
    "code": "AU-WA-CAM",
    "name": "Cambridge"
  },
  {
    "code": "AU-NSW-CMD",
    "name": "Camden"
  },
  {
    "code": "AU-VIC-CAM",
    "name": "Campaspe"
  },
  {
    "code": "AU-NSW-CAM",
    "name": "Campbelltown"
  },
  {
    "code": "AU-SA-CAM",
    "name": "Campbelltown"
  },
  {
    "code": "AU-NSW-CBY",
    "name": "Canada Bay"
  },
  {
    "code": "AU-WA-CAN",
    "name": "Canning"
  },
  {
    "code": "AU-NSW-CAN",
    "name": "Canterbury"
  },
  {
    "code": "AU-WA-CAP",
    "name": "Capel"
  },
  {
    "code": "AU-VIC-CAR",
    "name": "Cardinia"
  },
  {
    "code": "AU-WA-CNM",
    "name": "Carnamah"
  },
  {
    "code": "AU-WA-CAR",
    "name": "Carnarvon"
  },
  {
    "code": "AU-QLD-CAR",
    "name": "Carpentaria"
  },
  {
    "code": "AU-NSW-CAR",
    "name": "Carrathool"
  },
  {
    "code": "AU-VIC-CAS",
    "name": "Casey"
  },
  {
    "code": "AU-QLD-CAS",
    "name": "Cassowary Coast"
  },
  {
    "code": "AU-SA-CED",
    "name": "Ceduna"
  },
  {
    "code": "AU-TAS-CCO",
    "name": "Central Coast"
  },
  {
    "code": "AU-NSW-CEN",
    "name": "Central Darling"
  },
  {
    "code": "AU-NT-CEN",
    "name": "Central Desert"
  },
  {
    "code": "AU-VIC-CEN",
    "name": "Central Goldfields"
  },
  {
    "code": "AU-TAS-CHI",
    "name": "Central Highlands"
  },
  {
    "code": "AU-QLD-CEN",
    "name": "Central Highlands"
  },
  {
    "code": "AU-NSW-CES",
    "name": "Cessnock"
  },
  {
    "code": "AU-WA-CHA",
    "name": "Chapman Valley"
  },
  {
    "code": "AU-SA-CHA",
    "name": "Charles Sturt"
  },
  {
    "code": "AU-QLD-CHA",
    "name": "Charters Towers"
  },
  {
    "code": "AU-QLD-CHE",
    "name": "Cherbourg"
  },
  {
    "code": "AU-WA-CHI",
    "name": "Chittering"
  },
  {
    "code": "AU-TAS-CIR",
    "name": "Circular Head"
  },
  {
    "code": "AU-SA-CLA",
    "name": "Clare and Gilbert Valleys"
  },
  {
    "code": "AU-WA-CLA",
    "name": "Claremont"
  },
  {
    "code": "AU-TAS-CLA",
    "name": "Clarence"
  },
  {
    "code": "AU-NSW-CLA",
    "name": "Clarence Valley"
  },
  {
    "code": "AU-SA-CLE",
    "name": "Cleve"
  },
  {
    "code": "AU-QLD-CLO",
    "name": "Cloncurry"
  },
  {
    "code": "AU-NSW-COB",
    "name": "Cobar"
  },
  {
    "code": "AU-WA-COC",
    "name": "Cockburn"
  },
  {
    "code": "AU-NSW-COF",
    "name": "Coffs Harbour"
  },
  {
    "code": "AU-VIC-COL",
    "name": "Colac-Otway"
  },
  {
    "code": "AU-WA-COL",
    "name": "Collie"
  },
  {
    "code": "AU-NSW-CON",
    "name": "Conargo"
  },
  {
    "code": "AU-SA-COO",
    "name": "Coober Pedy"
  },
  {
    "code": "AU-QLD-COO",
    "name": "Cook"
  },
  {
    "code": "AU-NSW-CLM",
    "name": "Coolamon"
  },
  {
    "code": "AU-WA-CLG",
    "name": "Coolgardie"
  },
  {
    "code": "AU-NSW-CMO",
    "name": "Cooma-Monaro"
  },
  {
    "code": "AU-NT-COO",
    "name": "Coomalie"
  },
  {
    "code": "AU-NSW-COO",
    "name": "Coonamble"
  },
  {
    "code": "AU-WA-COO",
    "name": "Coorow"
  },
  {
    "code": "AU-NSW-CTM",
    "name": "Cootamundra"
  },
  {
    "code": "AU-SA-COP",
    "name": "Copper Coast"
  },
  {
    "code": "AU-VIC-COR",
    "name": "Corangamite"
  },
  {
    "code": "AU-NSW-COR",
    "name": "Corowa Shire"
  },
  {
    "code": "AU-WA-COR",
    "name": "Corrigin"
  },
  {
    "code": "AU-WA-COT",
    "name": "Cottesloe"
  },
  {
    "code": "AU-NSW-COW",
    "name": "Cowra"
  },
  {
    "code": "AU-WA-CRA",
    "name": "Cranbrook"
  },
  {
    "code": "AU-QLD-CRO",
    "name": "Croydon"
  },
  {
    "code": "AU-WA-CUB",
    "name": "Cuballing"
  },
  {
    "code": "AU-WA-CUE",
    "name": "Cue"
  },
  {
    "code": "AU-WA-CUN",
    "name": "Cunderdin"
  },
  {
    "code": "AU-WA-DAL",
    "name": "Dalwallinu"
  },
  {
    "code": "AU-WA-DAN",
    "name": "Dandaragan"
  },
  {
    "code": "AU-WA-DAR",
    "name": "Dardanup"
  },
  {
    "code": "AU-VIC-DAR",
    "name": "Darebin"
  },
  {
    "code": "AU-NT-DAR",
    "name": "Darwin"
  },
  {
    "code": "AU-NSW-DEN",
    "name": "Deniliquin"
  },
  {
    "code": "AU-WA-DEN",
    "name": "Denmark"
  },
  {
    "code": "AU-WA-DER",
    "name": "Derby-West Kimberley"
  },
  {
    "code": "AU-TAS-DER",
    "name": "Derwent Valley"
  },
  {
    "code": "AU-TAS-DEV",
    "name": "Devonport"
  },
  {
    "code": "AU-QLD-DIA",
    "name": "Diamantina"
  },
  {
    "code": "AU-WA-DON",
    "name": "Donnybrook-Balingup"
  },
  {
    "code": "AU-QLD-DOO",
    "name": "Doomadgee"
  },
  {
    "code": "AU-TAS-DOR",
    "name": "Dorset"
  },
  {
    "code": "AU-WA-DOW",
    "name": "Dowerin"
  },
  {
    "code": "AU-NSW-DUB",
    "name": "Dubbo"
  },
  {
    "code": "AU-WA-DUM",
    "name": "Dumbleyung"
  },
  {
    "code": "AU-WA-DUN",
    "name": "Dundas"
  },
  {
    "code": "AU-NSW-DUN",
    "name": "Dungog"
  },
  {
    "code": "AU-NT-EAS",
    "name": "East Arnhem"
  },
  {
    "code": "AU-WA-EFR",
    "name": "East Fremantle"
  },
  {
    "code": "AU-VIC-EAS",
    "name": "East Gippsland"
  },
  {
    "code": "AU-WA-EPI",
    "name": "East Pilbara"
  },
  {
    "code": "AU-SA-ELL",
    "name": "Elliston"
  },
  {
    "code": "AU-WA-ESP",
    "name": "Esperance"
  },
  {
    "code": "AU-QLD-ETH",
    "name": "Etheridge"
  },
  {
    "code": "AU-NSW-EUR",
    "name": "Eurobodalla"
  },
  {
    "code": "AU-WA-EXM",
    "name": "Exmouth"
  },
  {
    "code": "AU-NSW-FAI",
    "name": "Fairfield"
  },
  {
    "code": "AU-VIC-FAC",
    "name": "Falls Creek"
  },
  {
    "code": "AU-QLD-FLI",
    "name": "Flinders"
  },
  {
    "code": "AU-TAS-FLI",
    "name": "Flinders"
  },
  {
    "code": "AU-SA-FLI",
    "name": "Flinders Ranges"
  },
  {
    "code": "AU-NSW-FOR",
    "name": "Forbes"
  },
  {
    "code": "AU-SA-FRA",
    "name": "Franklin Harbour"
  },
  {
    "code": "AU-VIC-FRA",
    "name": "Frankston"
  },
  {
    "code": "AU-QLD-FRA",
    "name": "Fraser Coast"
  },
  {
    "code": "AU-WA-FRE",
    "name": "Fremantle"
  },
  {
    "code": "AU-VIC-FRE",
    "name": "French Island"
  },
  {
    "code": "AU-VIC-GAN",
    "name": "Gannawarra"
  },
  {
    "code": "AU-SA-GAW",
    "name": "Gawler"
  },
  {
    "code": "AU-TAS-GEO",
    "name": "George Town"
  },
  {
    "code": "AU-WA-GER",
    "name": "Geraldton-Greenough"
  },
  {
    "code": "AU-NSW-GIL",
    "name": "Gilgandra"
  },
  {
    "code": "AU-WA-GIN",
    "name": "Gingin"
  },
  {
    "code": "AU-QLD-GLA",
    "name": "Gladstone"
  },
  {
    "code": "AU-TAS-GLA",
    "name": "Glamorgan/Spring Bay"
  },
  {
    "code": "AU-VIC-GEI",
    "name": "Glen Eira"
  },
  {
    "code": "AU-NSW-GLE",
    "name": "Glen Innes Severn"
  },
  {
    "code": "AU-VIC-GLG",
    "name": "Glenelg"
  },
  {
    "code": "AU-TAS-GLE",
    "name": "Glenorchy"
  },
  {
    "code": "AU-NSW-GLO",
    "name": "Gloucester"
  },
  {
    "code": "AU-WA-GNO",
    "name": "Gnowangerup"
  },
  {
    "code": "AU-QLD-GOL",
    "name": "Gold Coast"
  },
  {
    "code": "AU-VIC-GOL",
    "name": "Golden Plains"
  },
  {
    "code": "AU-WA-GOO",
    "name": "Goomalling"
  },
  {
    "code": "AU-QLD-GOO",
    "name": "Goondiwindi"
  },
  {
    "code": "AU-NSW-GOS",
    "name": "Gosford"
  },
  {
    "code": "AU-WA-GOS",
    "name": "Gosnells"
  },
  {
    "code": "AU-NSW-GOU",
    "name": "Goulburn Mulwaree"
  },
  {
    "code": "AU-SA-GOY",
    "name": "Goyder"
  },
  {
    "code": "AU-SA-GRA",
    "name": "Grant"
  },
  {
    "code": "AU-NSW-GLA",
    "name": "Great Lakes"
  },
  {
    "code": "AU-VIC-GBE",
    "name": "Greater Bendigo"
  },
  {
    "code": "AU-VIC-GDA",
    "name": "Greater Dandenong"
  },
  {
    "code": "AU-VIC-GGE",
    "name": "Greater Geelong"
  },
  {
    "code": "AU-NSW-GHS",
    "name": "Greater Hume Shire"
  },
  {
    "code": "AU-VIC-GSH",
    "name": "Greater Shepparton"
  },
  {
    "code": "AU-NSW-GRT",
    "name": "Greater Taree"
  },
  {
    "code": "AU-NSW-GRI",
    "name": "Griffith"
  },
  {
    "code": "AU-NSW-GDG",
    "name": "Gundagai"
  },
  {
    "code": "AU-NSW-GUN",
    "name": "Gunnedah"
  },
  {
    "code": "AU-NSW-GUY",
    "name": "Guyra"
  },
  {
    "code": "AU-NSW-GWY",
    "name": "Gwydir"
  },
  {
    "code": "AU-QLD-GYM",
    "name": "Gympie"
  },
  {
    "code": "AU-WA-HAL",
    "name": "Halls Creek"
  },
  {
    "code": "AU-NSW-HAR",
    "name": "Harden"
  },
  {
    "code": "AU-WA-HAR",
    "name": "Harvey"
  },
  {
    "code": "AU-NSW-HAW",
    "name": "Hawkesbury"
  },
  {
    "code": "AU-NSW-HAY",
    "name": "Hay"
  },
  {
    "code": "AU-VIC-HEP",
    "name": "Hepburn"
  },
  {
    "code": "AU-QLD-HIN",
    "name": "Hinchinbrook"
  },
  {
    "code": "AU-VIC-HIN",
    "name": "Hindmarsh"
  },
  {
    "code": "AU-TAS-HOB",
    "name": "Hobart"
  },
  {
    "code": "AU-VIC-HOB",
    "name": "Hobsons Bay"
  },
  {
    "code": "AU-SA-HOL",
    "name": "Holdfast Bay"
  },
  {
    "code": "AU-NSW-HOL",
    "name": "Holroyd"
  },
  {
    "code": "AU-QLD-HOP",
    "name": "Hope Vale"
  },
  {
    "code": "AU-NSW-HOR",
    "name": "Hornsby"
  },
  {
    "code": "AU-VIC-HOR",
    "name": "Horsham"
  },
  {
    "code": "AU-VIC-HUM",
    "name": "Hume"
  },
  {
    "code": "AU-NSW-HUN",
    "name": "Hunters Hill"
  },
  {
    "code": "AU-TAS-HUO",
    "name": "Huon Valley"
  },
  {
    "code": "AU-NSW-HUR",
    "name": "Hurstville"
  },
  {
    "code": "AU-VIC-IND",
    "name": "Indigo"
  },
  {
    "code": "AU-NSW-INV",
    "name": "Inverell"
  },
  {
    "code": "AU-QLD-IPS",
    "name": "Ipswich"
  },
  {
    "code": "AU-WA-IRW",
    "name": "Irwin"
  },
  {
    "code": "AU-QLD-ISA",
    "name": "Isaac"
  },
  {
    "code": "AU-NSW-JER",
    "name": "Jerilderie"
  },
  {
    "code": "AU-WA-JER",
    "name": "Jerramungup"
  },
  {
    "code": "AU-WA-JPP",
    "name": "Joondalup"
  },
  {
    "code": "AU-NSW-JUN",
    "name": "Junee"
  },
  {
    "code": "AU-WA-KAL",
    "name": "Kalamunda"
  },
  {
    "code": "AU-WA-KAB",
    "name": "Kalgoorlie/Boulder"
  },
  {
    "code": "AU-SA-KAN",
    "name": "Kangaroo Island"
  },
  {
    "code": "AU-SA-KAR",
    "name": "Karoonda East Murray"
  },
  {
    "code": "AU-WA-KAT",
    "name": "Katanning"
  },
  {
    "code": "AU-NT-KAT",
    "name": "Katherine"
  },
  {
    "code": "AU-WA-KEL",
    "name": "Kellerberrin"
  },
  {
    "code": "AU-NSW-KEM",
    "name": "Kempsey"
  },
  {
    "code": "AU-WA-KEN",
    "name": "Kent"
  },
  {
    "code": "AU-TAS-KEN",
    "name": "Kentish"
  },
  {
    "code": "AU-NSW-KIA",
    "name": "Kiama"
  },
  {
    "code": "AU-SA-KIM",
    "name": "Kimba"
  },
  {
    "code": "AU-TAS-KNS",
    "name": "King Island"
  },
  {
    "code": "AU-TAS-KIN",
    "name": "Kingborough"
  },
  {
    "code": "AU-SA-KIN",
    "name": "Kingston"
  },
  {
    "code": "AU-VIC-KIN",
    "name": "Kingston"
  },
  {
    "code": "AU-VIC-KNO",
    "name": "Knox"
  },
  {
    "code": "AU-NSW-KOG",
    "name": "Kogarah"
  },
  {
    "code": "AU-WA-KOJ",
    "name": "Kojonup"
  },
  {
    "code": "AU-WA-KON",
    "name": "Kondinin"
  },
  {
    "code": "AU-WA-KOO",
    "name": "Koorda"
  },
  {
    "code": "AU-QLD-KOW",
    "name": "Kowanyama"
  },
  {
    "code": "AU-NSW-KRG",
    "name": "Ku-ring-gai"
  },
  {
    "code": "AU-WA-KUL",
    "name": "Kulin"
  },
  {
    "code": "AU-WA-KWI",
    "name": "Kwinana"
  },
  {
    "code": "AU-NSW-KYO",
    "name": "Kyogle"
  },
  {
    "code": "AU-NSW-LAC",
    "name": "Lachlan"
  },
  {
    "code": "AU-VIC-LJP",
    "name": "Lady Julia Percy Island"
  },
  {
    "code": "AU-WA-LAK",
    "name": "Lake Grace"
  },
  {
    "code": "AU-NSW-LAK",
    "name": "Lake Macquarie"
  },
  {
    "code": "AU-VIC-LAK",
    "name": "Lake Mountain"
  },
  {
    "code": "AU-NSW-LAN",
    "name": "Lane Cove"
  },
  {
    "code": "AU-VIC-LAT",
    "name": "Latrobe"
  },
  {
    "code": "AU-TAS-LAT",
    "name": "Latrobe"
  },
  {
    "code": "AU-TAS-LAU",
    "name": "Launceston"
  },
  {
    "code": "AU-WA-LAV",
    "name": "Laverton"
  },
  {
    "code": "AU-NSW-LEE",
    "name": "Leeton"
  },
  {
    "code": "AU-NSW-LEI",
    "name": "Leichhardt"
  },
  {
    "code": "AU-WA-LEO",
    "name": "Leonora"
  },
  {
    "code": "AU-SA-LIG",
    "name": "Light"
  },
  {
    "code": "AU-NSW-LIS",
    "name": "Lismore"
  },
  {
    "code": "AU-NT-LIT",
    "name": "Litchfield"
  },
  {
    "code": "AU-NSW-LIT",
    "name": "Lithgow"
  },
  {
    "code": "AU-NSW-LIV",
    "name": "Liverpool"
  },
  {
    "code": "AU-NSW-LIP",
    "name": "Liverpool Plains"
  },
  {
    "code": "AU-NSW-LOC",
    "name": "Lockhart"
  },
  {
    "code": "AU-QLD-LOR",
    "name": "Lockhart River"
  },
  {
    "code": "AU-QLD-LOV",
    "name": "Lockyer Valley"
  },
  {
    "code": "AU-VIC-LOD",
    "name": "Loddon"
  },
  {
    "code": "AU-QLD-LOG",
    "name": "Logan"
  },
  {
    "code": "AU-QLD-LON",
    "name": "Longreach"
  },
  {
    "code": "AU-NSW-LHI",
    "name": "Lord Howe Island"
  },
  {
    "code": "AU-SA-LOW",
    "name": "Lower Eyre Peninsula"
  },
  {
    "code": "AU-SA-LOX",
    "name": "Loxton Waikerie"
  },
  {
    "code": "AU-NT-MAC",
    "name": "MacDonnell"
  },
  {
    "code": "AU-VIC-MAC",
    "name": "Macedon Ranges"
  },
  {
    "code": "AU-QLD-MAC",
    "name": "Mackay"
  },
  {
    "code": "AU-NSW-MAI",
    "name": "Maitland"
  },
  {
    "code": "AU-SA-MAL",
    "name": "Mallala"
  },
  {
    "code": "AU-WA-MND",
    "name": "Mandurah"
  },
  {
    "code": "AU-WA-MNJ",
    "name": "Manjimup"
  },
  {
    "code": "AU-NSW-MAN",
    "name": "Manly"
  },
  {
    "code": "AU-VIC-MAN",
    "name": "Manningham"
  },
  {
    "code": "AU-VIC-MNS",
    "name": "Mansfield"
  },
  {
    "code": "AU-QLD-MAP",
    "name": "Mapoon"
  },
  {
    "code": "AU-SA-MAT",
    "name": "Maralinga Tjarutja"
  },
  {
    "code": "AU-QLD-MAR",
    "name": "Maranoa"
  },
  {
    "code": "AU-VIC-MBY",
    "name": "Maribyrnong"
  },
  {
    "code": "AU-SA-MAR",
    "name": "Marion"
  },
  {
    "code": "AU-VIC-MAR",
    "name": "Maroondah"
  },
  {
    "code": "AU-NSW-MAR",
    "name": "Marrickville"
  },
  {
    "code": "AU-QLD-MCK",
    "name": "McKinlay"
  },
  {
    "code": "AU-TAS-MEA",
    "name": "Meander Valley"
  },
  {
    "code": "AU-WA-MEE",
    "name": "Meekatharra"
  },
  {
    "code": "AU-VIC-MEL",
    "name": "Melbourne"
  },
  {
    "code": "AU-VIC-MLT",
    "name": "Melton"
  },
  {
    "code": "AU-WA-MEL",
    "name": "Melville"
  },
  {
    "code": "AU-WA-MEN",
    "name": "Menzies"
  },
  {
    "code": "AU-WA-MER",
    "name": "Merredin"
  },
  {
    "code": "AU-VIC-MOR",
    "name": "Merri-bek"
  },
  {
    "code": "AU-SA-MID",
    "name": "Mid Murray"
  },
  {
    "code": "AU-NSW-MID",
    "name": "Mid-Western Regional"
  },
  {
    "code": "AU-VIC-MIL",
    "name": "Mildura"
  },
  {
    "code": "AU-WA-MIN",
    "name": "Mingenew"
  },
  {
    "code": "AU-SA-MIT",
    "name": "Mitcham"
  },
  {
    "code": "AU-VIC-MIT",
    "name": "Mitchell"
  },
  {
    "code": "AU-VIC-MOI",
    "name": "Moira"
  },
  {
    "code": "AU-VIC-MON",
    "name": "Monash"
  },
  {
    "code": "AU-VIC-MVA",
    "name": "Moonee Valley"
  },
  {
    "code": "AU-WA-MOO",
    "name": "Moora"
  },
  {
    "code": "AU-VIC-MOO",
    "name": "Moorabool"
  },
  {
    "code": "AU-WA-MOR",
    "name": "Morawa"
  },
  {
    "code": "AU-NSW-MOR",
    "name": "Moree Plains"
  },
  {
    "code": "AU-QLD-MRB",
    "name": "Moreton Bay"
  },
  {
    "code": "AU-QLD-MOR",
    "name": "Mornington"
  },
  {
    "code": "AU-VIC-MPE",
    "name": "Mornington Peninsula"
  },
  {
    "code": "AU-NSW-MOS",
    "name": "Mosman"
  },
  {
    "code": "AU-WA-MOS",
    "name": "Mosman Park"
  },
  {
    "code": "AU-VIC-MOU",
    "name": "Mount Alexander"
  },
  {
    "code": "AU-SA-MTB",
    "name": "Mount Barker"
  },
  {
    "code": "AU-VIC-MBU",
    "name": "Mount Buller"
  },
  {
    "code": "AU-SA-MTG",
    "name": "Mount Gambier"
  },
  {
    "code": "AU-QLD-MOU",
    "name": "Mount Isa"
  },
  {
    "code": "AU-WA-MMA",
    "name": "Mount Magnet"
  },
  {
    "code": "AU-WA-MOU",
    "name": "Mount Marshall"
  },
  {
    "code": "AU-SA-MTR",
    "name": "Mount Remarkable"
  },
  {
    "code": "AU-VIC-MOY",
    "name": "Moyne"
  },
  {
    "code": "AU-VIC-MBB",
    "name": "Mt Baw Baw"
  },
  {
    "code": "AU-VIC-HOT",
    "name": "Mt Hotham"
  },
  {
    "code": "AU-WA-MUK",
    "name": "Mukinbudin"
  },
  {
    "code": "AU-WA-MUL",
    "name": "Mullewa"
  },
  {
    "code": "AU-WA-MUN",
    "name": "Mundaring"
  },
  {
    "code": "AU-WA-MRC",
    "name": "Murchison"
  },
  {
    "code": "AU-NSW-MUR",
    "name": "Murray"
  },
  {
    "code": "AU-WA-MUR",
    "name": "Murray"
  },
  {
    "code": "AU-SA-MUR",
    "name": "Murray Bridge"
  },
  {
    "code": "AU-VIC-MUR",
    "name": "Murrindindi"
  },
  {
    "code": "AU-NSW-MRM",
    "name": "Murrumbidgee"
  },
  {
    "code": "AU-QLD-MUR",
    "name": "Murweh"
  },
  {
    "code": "AU-NSW-MUS",
    "name": "Muswellbrook"
  },
  {
    "code": "AU-NSW-NAM",
    "name": "Nambucca"
  },
  {
    "code": "AU-WA-NAN",
    "name": "Nannup"
  },
  {
    "code": "AU-QLD-NAP",
    "name": "Napranum"
  },
  {
    "code": "AU-SA-NAR",
    "name": "Naracoorte and Lucindale"
  },
  {
    "code": "AU-WA-NRM",
    "name": "Narembeen"
  },
  {
    "code": "AU-NSW-NRB",
    "name": "Narrabri"
  },
  {
    "code": "AU-NSW-NRN",
    "name": "Narrandera"
  },
  {
    "code": "AU-WA-NAT",
    "name": "Narrogin"
  },
  {
    "code": "AU-WA-NAS",
    "name": "Narrogin"
  },
  {
    "code": "AU-NSW-NRM",
    "name": "Narromine"
  },
  {
    "code": "AU-WA-MED",
    "name": "Nedlands"
  },
  {
    "code": "AU-NSW-NEW",
    "name": "Newcastle"
  },
  {
    "code": "AU-WA-NGA",
    "name": "Ngaanyatjarraku"
  },
  {
    "code": "AU-NT-NHU",
    "name": "Nhulunbuy"
  },
  {
    "code": "AU-VIC-NIL",
    "name": "Nillumbik"
  },
  {
    "code": "AU-QLD-NBU",
    "name": "North Burnett"
  },
  {
    "code": "AU-NSW-NOR",
    "name": "North Sydney"
  },
  {
    "code": "AU-WA-NOR",
    "name": "Northam"
  },
  {
    "code": "AU-WA-NHP",
    "name": "Northampton"
  },
  {
    "code": "AU-NT-TOP",
    "name": "Northeast Top End"
  },
  {
    "code": "AU-SA-NOR",
    "name": "Northern Areas"
  },
  {
    "code": "AU-VIC-NOR",
    "name": "Northern Grampians"
  },
  {
    "code": "AU-TAS-NOR",
    "name": "Northern Midlands"
  },
  {
    "code": "AU-QLD-NPA",
    "name": "Northern Peninsula Area"
  },
  {
    "code": "AU-NSW-NWN",
    "name": "Northwestern NSW"
  },
  {
    "code": "AU-SA-NPS",
    "name": "Norwood Payneham St Peters"
  },
  {
    "code": "AU-WA-NUN",
    "name": "Nungarin"
  },
  {
    "code": "AU-NSW-OBE",
    "name": "Oberon"
  },
  {
    "code": "AU-SA-ONK",
    "name": "Onkaparinga"
  },
  {
    "code": "AU-NSW-ORA",
    "name": "Orange"
  },
  {
    "code": "AU-SA-ORR",
    "name": "Orroroo/Carrieton"
  },
  {
    "code": "AU-NSW-PAL",
    "name": "Palerang"
  },
  {
    "code": "AU-QLD-PAL",
    "name": "Palm Island"
  },
  {
    "code": "AU-NT-PAL",
    "name": "Palmerston"
  },
  {
    "code": "AU-NSW-PAR",
    "name": "Parkes"
  },
  {
    "code": "AU-QLD-PAR",
    "name": "Paroo"
  },
  {
    "code": "AU-NSW-PRM",
    "name": "Parramatta"
  },
  {
    "code": "AU-NSW-PEN",
    "name": "Penrith"
  },
  {
    "code": "AU-WA-PEP",
    "name": "Peppermint Grove"
  },
  {
    "code": "AU-WA-PRJ",
    "name": "Perenjori"
  },
  {
    "code": "AU-WA-PER",
    "name": "Perth"
  },
  {
    "code": "AU-SA-PET",
    "name": "Peterborough"
  },
  {
    "code": "AU-WA-PIN",
    "name": "Pingelly"
  },
  {
    "code": "AU-NSW-PIT",
    "name": "Pittwater"
  },
  {
    "code": "AU-WA-PLA",
    "name": "Plantagenet"
  },
  {
    "code": "AU-SA-PLA",
    "name": "Playford"
  },
  {
    "code": "AU-QLD-POR",
    "name": "Pormpuraaw"
  },
  {
    "code": "AU-SA-PAD",
    "name": "Port Adelaide Enfield"
  },
  {
    "code": "AU-SA-PAU",
    "name": "Port Augusta"
  },
  {
    "code": "AU-WA-POR",
    "name": "Port Hedland"
  },
  {
    "code": "AU-SA-PLI",
    "name": "Port Lincoln"
  },
  {
    "code": "AU-NSW-PMH",
    "name": "Port Macquarie-Hastings"
  },
  {
    "code": "AU-VIC-POR",
    "name": "Port Phillip"
  },
  {
    "code": "AU-SA-PPI",
    "name": "Port Pirie City and Dists"
  },
  {
    "code": "AU-NSW-PST",
    "name": "Port Stephens"
  },
  {
    "code": "AU-SA-PRO",
    "name": "Prospect"
  },
  {
    "code": "AU-VIC-PYR",
    "name": "Pyrenees"
  },
  {
    "code": "AU-WA-QUA",
    "name": "Quairading"
  },
  {
    "code": "AU-NSW-QUE",
    "name": "Queanbeyan"
  },
  {
    "code": "AU-VIC-QUE",
    "name": "Queenscliffe"
  },
  {
    "code": "AU-QLD-QUI",
    "name": "Quilpie"
  },
  {
    "code": "AU-NSW-RAN",
    "name": "Randwick"
  },
  {
    "code": "AU-WA-RAV",
    "name": "Ravensthorpe"
  },
  {
    "code": "AU-QLD-RED",
    "name": "Redland"
  },
  {
    "code": "AU-SA-REN",
    "name": "Renmark Paringa"
  },
  {
    "code": "AU-QLD-RIC",
    "name": "Richmond"
  },
  {
    "code": "AU-NSW-RIC",
    "name": "Richmond Valley"
  },
  {
    "code": "AU-SA-ROB",
    "name": "Robe"
  },
  {
    "code": "AU-NSW-ROC",
    "name": "Rockdale"
  },
  {
    "code": "AU-QLD-ROC",
    "name": "Rockhampton"
  },
  {
    "code": "AU-WA-ROC",
    "name": "Rockingham"
  },
  {
    "code": "AU-WA-ROE",
    "name": "Roebourne"
  },
  {
    "code": "AU-NT-ROP",
    "name": "Roper Gulf"
  },
  {
    "code": "AU-SA-ROX",
    "name": "Roxby Downs"
  },
  {
    "code": "AU-NSW-RYD",
    "name": "Ryde"
  },
  {
    "code": "AU-SA-SAL",
    "name": "Salisbury"
  },
  {
    "code": "AU-WA-SAN",
    "name": "Sandstone"
  },
  {
    "code": "AU-QLD-SCE",
    "name": "Scenic Rim"
  },
  {
    "code": "AU-WA-SER",
    "name": "Serpentine-Jarrahdale"
  },
  {
    "code": "AU-WA-SHA",
    "name": "Shark Bay"
  },
  {
    "code": "AU-NSW-SHE",
    "name": "Shellharbour"
  },
  {
    "code": "AU-NSW-SHO",
    "name": "Shoalhaven"
  },
  {
    "code": "AU-NSW-SIN",
    "name": "Singleton"
  },
  {
    "code": "AU-NSW-SNO",
    "name": "Snowy River"
  },
  {
    "code": "AU-QLD-SOM",
    "name": "Somerset"
  },
  {
    "code": "AU-TAS-SOR",
    "name": "Sorell"
  },
  {
    "code": "AU-QLD-SOB",
    "name": "South Burnett"
  },
  {
    "code": "AU-VIC-SGI",
    "name": "South Gippsland"
  },
  {
    "code": "AU-WA-SOU",
    "name": "South Perth"
  },
  {
    "code": "AU-QLD-SOD",
    "name": "Southern Downs"
  },
  {
    "code": "AU-VIC-SGR",
    "name": "Southern Grampians"
  },
  {
    "code": "AU-SA-SOU",
    "name": "Southern Mallee"
  },
  {
    "code": "AU-TAS-SOU",
    "name": "Southern Midlands"
  },
  {
    "code": "AU-WA-STI",
    "name": "Stirling"
  },
  {
    "code": "AU-VIC-STO",
    "name": "Stonnington"
  },
  {
    "code": "AU-VIC-STR",
    "name": "Strathbogie"
  },
  {
    "code": "AU-NSW-STR",
    "name": "Strathfield"
  },
  {
    "code": "AU-SA-STR",
    "name": "Streaky Bay"
  },
  {
    "code": "AU-WA-SUB",
    "name": "Subiaco"
  },
  {
    "code": "AU-QLD-SUN",
    "name": "Sunshine Coast"
  },
  {
    "code": "AU-VIC-SUR",
    "name": "Surf Coast"
  },
  {
    "code": "AU-NSW-SUT",
    "name": "Sutherland Shire"
  },
  {
    "code": "AU-WA-SWA",
    "name": "Swan"
  },
  {
    "code": "AU-VIC-SWA",
    "name": "Swan Hill"
  },
  {
    "code": "AU-NSW-SYD",
    "name": "Sydney"
  },
  {
    "code": "AU-QLD-TAB",
    "name": "Tablelands"
  },
  {
    "code": "AU-WA-TAM",
    "name": "Tammin"
  },
  {
    "code": "AU-NSW-TAM",
    "name": "Tamworth Regional"
  },
  {
    "code": "AU-TAS-TAS",
    "name": "Tasman"
  },
  {
    "code": "AU-SA-TAT",
    "name": "Tatiara"
  },
  {
    "code": "AU-SA-TEA",
    "name": "Tea Tree Gully"
  },
  {
    "code": "AU-NSW-TEM",
    "name": "Temora"
  },
  {
    "code": "AU-NSW-TEN",
    "name": "Tenterfield"
  },
  {
    "code": "AU-SA-THE",
    "name": "The Coorong"
  },
  {
    "code": "AU-NSW-THE",
    "name": "The Hills Shire"
  },
  {
    "code": "AU-WA-THR",
    "name": "Three Springs"
  },
  {
    "code": "AU-NT-TIW",
    "name": "Tiwi Islands"
  },
  {
    "code": "AU-WA-TOO",
    "name": "Toodyay"
  },
  {
    "code": "AU-QLD-TOO",
    "name": "Toowoomba"
  },
  {
    "code": "AU-QLD-TOR",
    "name": "Torres"
  },
  {
    "code": "AU-QLD-TSI",
    "name": "Torres Strait Island"
  },
  {
    "code": "AU-QLD-TOW",
    "name": "Townsville"
  },
  {
    "code": "AU-VIC-TOW",
    "name": "Towong"
  },
  {
    "code": "AU-WA-TRA",
    "name": "Trayning"
  },
  {
    "code": "AU-NSW-TMB",
    "name": "Tumbarumba"
  },
  {
    "code": "AU-SA-TUM",
    "name": "Tumby Bay"
  },
  {
    "code": "AU-NSW-TMT",
    "name": "Tumut Shire"
  },
  {
    "code": "AU-NSW-TWE",
    "name": "Tweed"
  },
  {
    "code": "AU-SA-UNI",
    "name": "Unincorporated SA"
  },
  {
    "code": "AU-SA-UNL",
    "name": "Unley"
  },
  {
    "code": "AU-WA-UPP",
    "name": "Upper Gascoyne"
  },
  {
    "code": "AU-NSW-UPH",
    "name": "Upper Hunter Shire"
  },
  {
    "code": "AU-NSW-UPL",
    "name": "Upper Lachlan Shire"
  },
  {
    "code": "AU-NSW-URL",
    "name": "Uralla"
  },
  {
    "code": "AU-NSW-URN",
    "name": "Urana"
  },
  {
    "code": "AU-SA-VIC",
    "name": "Victor Harbor"
  },
  {
    "code": "AU-WA-VPA",
    "name": "Victoria Park"
  },
  {
    "code": "AU-WA-VPL",
    "name": "Victoria Plains"
  },
  {
    "code": "AU-NT-VIC",
    "name": "Victoria-Daly"
  },
  {
    "code": "AU-WA-VIN",
    "name": "Vincent"
  },
  {
    "code": "AU-NT-WAG",
    "name": "Wagait"
  },
  {
    "code": "AU-NSW-WAG",
    "name": "Wagga Wagga"
  },
  {
    "code": "AU-WA-WAG",
    "name": "Wagin"
  },
  {
    "code": "AU-SA-WAK",
    "name": "Wakefield"
  },
  {
    "code": "AU-NSW-WAK",
    "name": "Wakool"
  },
  {
    "code": "AU-NSW-WLC",
    "name": "Walcha"
  },
  {
    "code": "AU-NSW-WAL",
    "name": "Walgett"
  },
  {
    "code": "AU-SA-WAL",
    "name": "Walkerville"
  },
  {
    "code": "AU-WA-WND",
    "name": "Wandering"
  },
  {
    "code": "AU-VIC-WAN",
    "name": "Wangaratta"
  },
  {
    "code": "AU-WA-WAN",
    "name": "Wanneroo"
  },
  {
    "code": "AU-TAS-WAR",
    "name": "Waratah/Wynyard"
  },
  {
    "code": "AU-WA-WAR",
    "name": "Waroona"
  },
  {
    "code": "AU-NSW-WRR",
    "name": "Warren"
  },
  {
    "code": "AU-NSW-WRG",
    "name": "Warringah"
  },
  {
    "code": "AU-VIC-WAR",
    "name": "Warrnambool"
  },
  {
    "code": "AU-NSW-WRM",
    "name": "Warrumbungle Shire"
  },
  {
    "code": "AU-SA-WAT",
    "name": "Wattle Range"
  },
  {
    "code": "AU-NSW-WAV",
    "name": "Waverley"
  },
  {
    "code": "AU-NSW-WED",
    "name": "Weddin"
  },
  {
    "code": "AU-QLD-WEI",
    "name": "Weipa"
  },
  {
    "code": "AU-NSW-WEL",
    "name": "Wellington"
  },
  {
    "code": "AU-VIC-WEL",
    "name": "Wellington"
  },
  {
    "code": "AU-NSW-WEN",
    "name": "Wentworth"
  },
  {
    "code": "AU-NT-WES",
    "name": "West Arnhem"
  },
  {
    "code": "AU-WA-WEA",
    "name": "West Arthur"
  },
  {
    "code": "AU-TAS-WEC",
    "name": "West Coast"
  },
  {
    "code": "AU-TAS-WET",
    "name": "West Tamar"
  },
  {
    "code": "AU-SA-WES",
    "name": "West Torrens"
  },
  {
    "code": "AU-VIC-WES",
    "name": "West Wimmera"
  },
  {
    "code": "AU-QLD-WES",
    "name": "Western Downs"
  },
  {
    "code": "AU-WA-WES",
    "name": "Westonia"
  },
  {
    "code": "AU-VIC-WHO",
    "name": "Whitehorse"
  },
  {
    "code": "AU-QLD-WHI",
    "name": "Whitsunday"
  },
  {
    "code": "AU-VIC-WHI",
    "name": "Whittlesea"
  },
  {
    "code": "AU-SA-WHY",
    "name": "Whyalla"
  },
  {
    "code": "AU-WA-WIC",
    "name": "Wickepin"
  },
  {
    "code": "AU-WA-WLL",
    "name": "Williams"
  },
  {
    "code": "AU-NSW-WIL",
    "name": "Willoughby"
  },
  {
    "code": "AU-VIC-WPI",
    "name": "Wilsons Promontory Islands"
  },
  {
    "code": "AU-WA-WLN",
    "name": "Wiluna"
  },
  {
    "code": "AU-NSW-WIN",
    "name": "Wingecarribee"
  },
  {
    "code": "AU-QLD-WIN",
    "name": "Winton"
  },
  {
    "code": "AU-VIC-WOD",
    "name": "Wodonga"
  },
  {
    "code": "AU-NSW-WOL",
    "name": "Wollondilly"
  },
  {
    "code": "AU-NSW-WLG",
    "name": "Wollongong"
  },
  {
    "code": "AU-WA-WON",
    "name": "Wongan-Ballidu"
  },
  {
    "code": "AU-WA-WOO",
    "name": "Woodanilling"
  },
  {
    "code": "AU-NSW-WOO",
    "name": "Woollahra"
  },
  {
    "code": "AU-QLD-WOO",
    "name": "Woorabinda"
  },
  {
    "code": "AU-SA-WUD",
    "name": "Wudinna"
  },
  {
    "code": "AU-QLD-WUJ",
    "name": "Wujal Wujal"
  },
  {
    "code": "AU-WA-WYA",
    "name": "Wyalkatchem"
  },
  {
    "code": "AU-VIC-WYN",
    "name": "Wyndham"
  },
  {
    "code": "AU-WA-WYN",
    "name": "Wyndham-East Kimberley"
  },
  {
    "code": "AU-NSW-WYO",
    "name": "Wyong"
  },
  {
    "code": "AU-WA-YAL",
    "name": "Yalgoo"
  },
  {
    "code": "AU-SA-YAN",
    "name": "Yankalilla"
  },
  {
    "code": "AU-VIC-YAR",
    "name": "Yarra"
  },
  {
    "code": "AU-VIC-YRA",
    "name": "Yarra Ranges"
  },
  {
    "code": "AU-QLD-YAR",
    "name": "Yarrabah"
  },
  {
    "code": "AU-VIC-YMB",
    "name": "Yarriambiack"
  },
  {
    "code": "AU-NSW-YAS",
    "name": "Yass Valley"
  },
  {
    "code": "AU-WA-YIL",
    "name": "Yilgarn"
  },
  {
    "code": "AU-WA-YOR",
    "name": "York"
  },
  {
    "code": "AU-SA-YOR",
    "name": "Yorke Peninsula"
  },
  {
    "code": "AU-NSW-YOU",
    "name": "Young"
  },
  {
    "code": "AU-NT-YUL",
    "name": "Yulara"
  }
]